// 用于存储APP消息监听器的引用
const appMessageListeners = new Set();

// 专门处理APP消息的监听器
export function createAppMessageListener(identifier, resolve, reject, typeCheck = null) {
    const listener = function(event) {
        try {
            const data = JSON.parse(event.data);
            const payload = data.payload;
            
            // 根据typeCheck参数决定如何匹配
            let isMatch = false;
            if (typeCheck && data.type === typeCheck) {
                // 如果指定了typeCheck，则同时检查type和identifier
                // identifier可以是callbackId或messageId
                isMatch = true;
            } else {
                // 如果指定了typeCheck但类型不匹配
                isMatch = false;
            }
            
            if (isMatch) {
                // 移除当前监听器
                // window.removeEventListener('message', listener);
                if (appMessageListeners) {
                    appMessageListeners.delete(listener);
                }
                
                if (payload.success) {
                    resolve(payload);
                } else {
                    reject(new Error(data.error || 'Request failed'));
                }
            }
        } catch (e) {
        // 忽略非JSON消息或其他错误
        }
    };
    
    // 将监听器添加到集合中，便于管理
    if (appMessageListeners) {
        appMessageListeners.add(listener);
    }
    return listener;
}

export function addAppMessageListener(listener) {
    window.addEventListener('message', listener);
    window.document.addEventListener('message', listener);
}

export function removeAppMessageListener(listener) {
    window.removeEventListener('message', listener);
    window.document.removeEventListener('message', listener);
}
